
import axiosRequest from "../universal/axiosService";
import { ENDPOINTS } from "../../apiConfig";

export const fetchTeamLead = async (params = {}) => {

  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.TEAMLEAD.GET_ALL,
    params: {
      coll: params.coll,
      fil: JSON.stringify(params.filters),
      ret: params.ret,
      ref: params.ref,
      lim: params.limit,
      pg: params.page,
      extret: params.extret,
      useAggregate: true,
      queryMode: params.queryMode
    },
  });
};


export const fetchCompanies = async ({ limit, page, filters, ret, sort, postActions, ref, incl,queryMode }) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.COMPANIES.GET_ALL,
    params: {
      coll: "Company",
      lim: limit || 10,
      pg: page || 1,
      fil: JSON.stringify(filters),
      ret: ret || null,
      ...(sort && { sort: JSON.stringify(sort) }),
      ...(postActions && { postActions }),
      ...(queryMode && { queryMode }),
      cache: false,
      errorHandler: true,
      ref : ref || null,
      incl : incl || null,
    },
  });
};

export const fetchCompanyByUiid = async ({ filters, ref, ret, extret,aggregate=false }) => {
  return await axiosRequest({
    method: "GET",
    url: aggregate?ENDPOINTS.COMPANIES.GET_ALL:ENDPOINTS.COMPANIES.GET_BY_UIID,
    params: {
      coll: "Company",
      fil: JSON.stringify(filters),
      ret: ret || null,
      ref: ref || null,
      cache: false,
      errorHandler: true,
      extret: extret || null,
      useAggregate: aggregate,
    },
  })
}

export const addCompanyApi = async ({ payload, }) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.COMPANIES.ADD_NEW,
    data: payload,
    cache: false,
    errorHandler: true,
  });
};



export const fetchJobByFilters = async ({ companyId, state, city, ref = "Propects", ret }) => {
  const filters = {
    companyId: { type: "NONE", value: companyId },
    ...(state ? { "location.state": { type: "NONE", value: state } } : {}),
    ...(city ? { "location.city": { type: "NONE", value: city } } : {}),
  };

  try {
    const response = await axiosRequest({
      method: "GET",
      url: ENDPOINTS.JOBS.GET_ALL,
      params: {
        coll: "Job",
        ref, // default "Propects"
        fil: JSON.stringify(filters),
        ...(ret && { ret }),
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching jobs by filters:", error);
    throw error;
  }
};

export const addJobApi = async ({ payload }) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.JOBS.ADD,
    data: payload,
    cache: false,
    errorHandler: true,
  });
};

export const deleteJobApi = async ({ uiid }) => {
  if (!uiid) throw new Error("Job uiid is required");

  const payload = {
    coll: "Job",
    uiid,
  };

  return await axiosRequest({
    method: "DELETE",
    url: ENDPOINTS.JOBS.DELETE,
    data: payload,
  });
};

export const deleteCompanyApi = async ({ uiid }) => {
  if (!uiid) throw new Error("Company uiid is required");

  const payload = {
    coll: "Company",
    uiid,
  };

  return await axiosRequest({
    method: "DELETE",
    url: ENDPOINTS.COMPANIES.DELETE,
    data: payload,
  });
};

export const deleteJobOrCompany = async ({ company, jobUiid }) => {
  const today = new Date().toISOString().split("T")[0];
  const addedOnDate = new Date(company.addedOn).toISOString().split("T")[0];

  if (jobUiid) {
    await deleteJobApi({ uiid: jobUiid });
    if (addedOnDate === today) {
      await deleteCompanyApi({ uiid: company.uiid });
      return { message: "Job and Company deleted successfully" };
    }

    return { message: "Job deleted successfully" };
  } else {
    await deleteCompanyApi({ uiid: company.uiid });
    return { message: "Company deleted successfully" };
  }
};

export const fetchProspects = async ({ limit, page, filters, ret, sort }) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.PROSPECTS.GET_ALL,
    params: {
      coll: "Prospect",
      lim: limit || 10,
      pg: page || 1,
      fil: JSON.stringify(filters),
      ret: ret || "uiid email companyId",
      ...(sort && { sort: JSON.stringify(sort) }),
      cache: false,
    },
  });
};


export const fetchJobById = async (jobId, ref = "Propects") => {
  if (!jobId) throw new Error("jobId is required");

  try {
    const response = await axiosRequest({
      method: "GET",
      url: `${ENDPOINTS.JOBS.GET}`,
      params: {
        coll: "Job",
        fil: JSON.stringify({ uiid: { type: "NONE", value: jobId } }),
        ref,
        cache: false, // Ensure fresh data is fetched
        _t: Date.now(), // Force cache bust to prevent 304 Not Modified
      },
    });

    return response?.data?.data;
  } catch (error) {
    console.error("Error fetching job by ID:", error);
    throw error;
  }
};

// export const updateJobApi = async ({ uiid, jobFields, prospects = [] }) => {
//   if (!uiid) throw new Error("uiid is required");
//   if (!jobFields || Object.keys(jobFields).length === 0) throw new Error("jobFields is required");

//   const formattedProspects = prospects.map((p) => ({
//     uiid: p.uiid || null, 
//     firstName: p.firstName || "",
//     lastName: p.lastName || "",
//     designation: p.designation || "",
//     mobile: {
//       code: p.phoneCode || "+91",
//       number: p.phoneNumber || "",
//     },
//     email: p.email || "",
//     location: p.contactLocation || null,
//   }));

//   const payload = {
//     postActions: ["AddToProspect"],
//     payload: [
//       {
//         type: "SET",
//         value: jobFields,
//       },
//     ],
//     additionalPayload: {
//       Prospects: formattedProspects,
//     },
//   };

//   return await axiosRequest({
//     method: "PATCH",
//     url:` ${ENDPOINTS.JOBS.UPDATE}`,
//     data: payload,
//     cache: false,
//     errorHandler: true,
//   });
// };

export const fetchTodaysCompanies = async ({ limit = 10, page = 1, filters, sort }) => {
  try {
    const response = await axiosRequest({
      method: "GET",
      url: ENDPOINTS.JOBS.GET_ALL,
      params: {
        coll: "Job",
        useAggregate: true,
        fil: JSON.stringify(filters),
        lim: limit,
        pg: page,
        sort: JSON.stringify(sort),
        queryMode:"AG_COMPANYJOBS",
        cache: false, // Ensure fresh data is fetched
        _t: Date.now(), // Force cache bust to prevent 304 Not Modified
      },
    });
    return response?.data;
  } catch (error) {
    console.error("Error fetching today’s companies:", error);
    throw error;
  }
};


export const updateJobApi = async ({ uiid, payload }) => {

  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.JOBS.UPDATE}?coll=Job&uiid=${uiid}`,
    data: payload,
    cache: false,
    errorHandler: true,
  });
};


export const fetchCompanyJobCountsApi = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.COMPANIES.GET_ALL,
    params: {
      ...params,
      fil: JSON.stringify(params.fil),
    },
  });
};

export const MyLeadsCardCount = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.JOBS.GET_ALL,
    params: {
      ...params,
    },
  });
};

export const bulkUploadApi = async ({ payload }) => {
  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.PROSPECTS.BULK_UPDATE}?coll=Prospect`,
    data: { payload },
    // cache: false,
    // errorHandler: true,
  });
};
export const fetchRaSettingsApi = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.SETTINGS.GET_ALL,
    params: {
      ...params,
      // fil: JSON.stringify(params?.fil), 
    },
  });
};

export const fetchJobsByMultipleIds = async (jobIds = [], ref = "Company Propects") => {
  if (!jobIds.length) return {};

  try {
    const response = await axiosRequest({
      method: "GET",
      url: `${ENDPOINTS.JOBS.GET_ALL}`,
      params: {
        coll: "Job",
        lim: jobIds.length,
        pg: 1,
        ret: "uiid title",
        ref,
        fil: JSON.stringify({
          uiid: {
            type: "IN",
            value: jobIds,
          },
        }),
      },
    });

    const jobsArray = response?.data?.data || [];

    // Convert array to mapping { jobId: jobData }
    const jobsMap = jobsArray.reduce((acc, job) => {
      acc[job.uiid] = job;
      return acc;
    }, {});

    return jobsMap;
  } catch (error) {
    console.error("Error fetching jobs by IDs:", error);
    throw error;
  }
};


export const saveRaSettingsApi = async (payload) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.SETTINGS.ADD, // your POST endpoint
    data: payload, // send the payload here, not params
  });
};

export const updateRaSettingsApi = async ({ uiid, payload }) => {

  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.SETTINGS.UPDATE}?coll=Setting&uiid=${uiid}`,
    data: payload,

  });
};

export const updateCompanystatusApi = async ({ uiid, payload }) => {
  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.COMPANIES.UPDATE}?coll=Company&uiid=${uiid}`,
    data: payload,

  });
};

export const updateEmailstatusApi = async ({ uiid, payload }) => {
  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.PROSPECTS.UPDATE}?coll=Prospect&uiid=${uiid}`,
    data: payload,
  });
};

export const fetchProspectsApi = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.JOBS.GET_ALL,
    params: {
      ...params,

    },
  });
};

export const fetchDailyproduction = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.COMPANIES.GET_ALL,
    params: {
      ...params,

    },
  });
};

export const fetchAllteamApi = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.JOBS.GET_ALL,
    params: {
      ...params,

    },
  });
};

export const mergeCompanyApi = async ({ payload }) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.COMPANIES.MERGE,
    data: payload,
    cache: false,
    errorHandler: true,
  });
};

export const fetchTeamSummaryApi = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.JOBS.GET_ALL,
    params: {
      ...params,

    },
  });
};

export const fetchRaReportsModal = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.JOBS.GET_ALL,
    params: {
      ...params,

    },
  });
};


